import React from "react";
import ProductCard from "./ProductCard";

const ProductList = ({
  categories,
  menus,
  onAddToCart,
  handleFilterByCategory,
  filterOptions,
}) => {
  return (
    <>
    <div>
        {/* <select
              className="form-select"
              onChange={(e) => handleSearch(e, "category")}
              defaultValue={filterOptions.category}
            > */}
        <select
          className="form-select"
          value={filterOptions.filters?.["categories.id"] || ""}
          onChange={(e) => handleFilterByCategory(e.target.value)}
        >
          <option value="">All Categories</option>
          {categories.map((category) => (
            <option key={category.id} value={category.id}>
              {category.name}
            </option>
          ))}
        </select>
      </div>
    <div
      className="d-grid gap-2 p-2"
      style={{
        gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))",
        justifyContent: "center",
        maxHeight: "90vh", // Batasi tinggi agar bisa di-scroll
        overflowY: "auto", // Tambahkan scrollbar hanya di list produk
      }}
    >
      
      {menus.map((product) => (
        <ProductCard
          key={product.id}
          product={product}
          onAddToCart={onAddToCart}
          categories={categories}
        />
      ))}
    </div>
    </>
  );
};

export default ProductList;
